import {
  getThemeSettings,
  initializeThemeSync,
  themeChangeEventName,
  toggleThemeMode,
} from '../lib/themePreferences';

let cleanupThemeSync;
let toggleHandlerAttached = false;
let themeChangeListenerAttached = false;

const updateThemeToggleVisibility = (settings = getThemeSettings()) => {
  const themeSwitch = document.querySelector('.theme-switch');
  if (!themeSwitch) return;

  themeSwitch.classList.toggle('hidden', Boolean(settings.syncWithDevice));
};

const attachToggleHandler = () => {
  const themeToggleButton = document.getElementById('theme-toggle-btn');
  if (!themeToggleButton || toggleHandlerAttached) return;

  themeToggleButton.addEventListener('click', () => {
    toggleThemeMode();
  });
  toggleHandlerAttached = true;
};

export const initializeThemeSwitch = () => {
  if (!cleanupThemeSync) {
    cleanupThemeSync = initializeThemeSync();
  }

  updateThemeToggleVisibility();
  attachToggleHandler();

  if (!themeChangeListenerAttached) {
    window.addEventListener(themeChangeEventName, (event) => {
      updateThemeToggleVisibility({
        mode: event.detail?.mode === 'dark' ? 'dark' : 'light',
        syncWithDevice: Boolean(event.detail?.syncWithDevice),
      });
    });
    themeChangeListenerAttached = true;
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeThemeSwitch, { once: true });
} else {
  initializeThemeSwitch();
}
